<template>
  <div id="signup-selection">
    <div class="agencySignup-container">
      <LeftView v-bind:coverImage="coverImage" />
      <div class="right-view">
        <have-account v-bind:haveAccountData="haveAccountData" />
        <onboarding-form
          v-bind:errorExists="errorExists"
          v-bind:formData="formData"
          v-on:changeInput="handleChange"
          v-bind:errors="errors"
          v-on:setErrorExists="setErrorExists"
          v-bind:formTitleText="formTitleText"
          v-bind:formSubtext="formSubtext"
          v-bind:formFields="formFields"
          v-bind:hintText="hintText"
          v-bind:baseLink="baseLink"
          v-bind:buttonText="buttonText"
          v-on:userData="userData"
          :toggle="toggle"
          v-on:toggleAnimation="lockChild"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LeftView from '../../components/SignupSelection/LeftView.vue';
import coverImage from '../../assets/images/signup-cover-image.jpg';
import OnboardingForm from '../../components/body/OnboardingForm.vue';
import HaveAccount from '../../components/body/HaveAccount.vue';
export default {
  components: { LeftView, OnboardingForm, HaveAccount },
  name: 'AgencySignup',
  data() {
    return {
      formData:{
        agencyName: null,
        firstName: null,
        lastName: null,
        emailAddress: null,
        phone: null,
        password: null
      },
      errors:{
        agencyNameError: false,
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        phoneError:false,
        passwordError: false,
      },
      errorExists: false,
      toggle: false,
      haveAccountData: {
        haveAccountTitle: 'Already have an account?',
        haveAccountButtonText: 'Sign In',
        haveAccountLink: '/login',
      },
      formTitleText: 'Create your agency account',
      formSubtext: 'Please enter your details to continue.',
      formFields: [
        { name: 'agencyName', placeholder: 'Agency Name', type: 'text', errorName:'agencyNameError' },
        { name: 'firstName', placeholder: 'First Name', type: 'text', errorName:'firstNameError' },
        { name: 'lastName', placeholder: 'Last Name', type: 'text', errorName:'lastNameError' },
        { name: 'emailAddress', placeholder: 'Email', type: 'email', errorName:'emailError' },
        { name: 'phone', placeholder: 'Phone Number', type: 'tel', errorName:'phoneError' },
        { name: 'password', placeholder: 'Password', type: 'password', errorName:'passwordError' },
      ],
      baseLink: { link: '', text: '' },
      hintText:
        'Password Hint: Enter a combination of letters, numbers, and special characters of not less than eight characters',
      buttonText: 'Sign Up',
      coverImage: coverImage,
    };
  },

  methods: {
    setErrorExists(value){
      this.errorExists = value;
    },
    handleChange(data){
      switch(data.name){
        case 'agencyName':
          this.formData.agencyName = data.value;
          break;

        case 'firstName':
          this.formData.firstName = data.value;
          break;

        case 'lastName':
          this.formData.lastName = data.value;
          break;

        case 'emailAddress':
          this.formData.emailAddress = data.value;
          break;

        case 'phone':
          this.formData.phone = data.value;
          break;

        case 'password':
          this.formData.password = data.value;
          break;
      }
    },
    permitChild() {
      this.toggle = true;
    },
    lockChild() {
      this.toggle = false;
    },
    userData(data) {
      this.$store
        .dispatch('userSignup', data)
        .then((res) => {
          this.permitChild();
          if (res.response) {
            this.$toastr.success(res.response.message, 'Success');
            setTimeout(() => this.$router.push('/login'), 3000);
          } else {
            res.error.error
              ? this.$toastr.error(res.error.error, 'Signup Failed')
              : this.$toastr.error(
                  'Couldn\'t establish connection',
                  res.error.message
              );
          }
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
</script>
<style scoped>
  .agencySignup-container {
    display: flex;
  }
</style>
